import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getBostonStructuredData() {
  const url = "https://restorehair.com/locations/massachusetts/boston/";
  const description =
    "Find out about your hair transplant options in Boston with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("boston", url, description),
    locationPageCrumbs(url, "Boston"),
  ];
}
